import { render, staticRenderFns } from "./user_cwgl.vue?vue&type=template&id=7882cfb9&scoped=true"
import script from "./user_cwgl.vue?vue&type=script&lang=js"
export * from "./user_cwgl.vue?vue&type=script&lang=js"
import style0 from "./user_cwgl.vue?vue&type=style&index=0&id=7882cfb9&prod&scoped=true&lang=less"
import style1 from "./user_cwgl.vue?vue&type=style&index=1&id=7882cfb9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7882cfb9",
  null
  
)

export default component.exports